import { RootState } from 'handlers';

export const getLoanOffer = ({ loanOffer }: RootState) => loanOffer;
export const getLoanOfferData = ({ loanOffer }: RootState) => loanOffer.response;
